import React from "react";
import {
    PieChart, Pie, Cell,
    ResponsiveContainer, Legend, Tooltip,
} from "recharts";
import Firebase from "../../Firebase";
import distinctColors from 'distinct-colors'
import {useCollection} from "react-firebase-hooks/firestore";


const db = Firebase.firestore();
const MostSoldProduct = (props) => {


    var moment = require('moment');

    const [dataArray, setDataArray] = React.useState([]);
    const [products] = useCollection(
        db.collection('products'),
        {
            snapshotListenOptions: { includeMetadataChanges: true },
        }
    );
    const [sales] = useCollection(
        db.collection('sales'),
        {
            snapshotListenOptions: { includeMetadataChanges: true },
        }
    );
    const [weekdays, setWeekDays] = React.useState([]);
    const [labelArray, setLabelArray] = React.useState([]);
    const [loading , setLoading] = React.useState(false);
    const [paletteArray, setPaletteArray] = React.useState([]);

    var todayNum = moment().isoWeekday();
    //var lastWeekToday = todayNum - 14;

    React.useEffect(() => {

        setLoading(true);

        var number;
        if(props.period === "Last 7 days"){
            number = 7;
        }else if(props.period === "Last 30 days"){
            number = 30;
        } else {
            number = 90;
        }

        //console.log(props.period);

        var weekArray = [];
        var labelArray = [];

        for(var i=0; i < number; i++){
            weekArray.push({"date" : moment().weekday(todayNum - i).format("YYYY-MM-DD"),
                "name" : moment().weekday(todayNum - i).format('DD/MM')});
            labelArray.push(moment().weekday(todayNum - i).format('DD/MM'))
        }

        setLabelArray(labelArray);
        setWeekDays(weekArray);

        var productArray = [];
        if(products){
            products.docs.map((item) => {
                productArray.push(item.data());
            })
        }

        if(sales){
            var salesArray = []
            sales.docs.map((item) => {
                salesArray.push(item.data());
            })
            var tempArray= []
            weekArray.map((weekday, index) => {


                var dataItem = {
                    name : moment(weekday.date, "YYYY-MM-DD").format("DD/MM")
                };
                var filtered = salesArray.filter(x => (moment(x.updatedAt, "YYYY-MM-DD h:mm:SSS").format("YYYY-MM-DD") === weekday.date));
                filtered.map((item, ind) => {
                    //console.log(item);
                    var name = productArray[productArray.findIndex(x => (x.productID) === item.productID)]&&
                        productArray[productArray.findIndex(x => (x.productID) === item.productID)].name;
                    if(dataItem[name] == null || dataItem[name] === undefined){
                        dataItem[name] = 1;
                    } else {
                        dataItem[name] = dataItem[name] + 1;
                    }
                });

                productArray.map((item) => {
                    if(dataItem[item.name]== null || dataItem[item.name] === undefined) {
                        dataItem[item.name] = 0;
                    }
                });
                tempArray.push(dataItem);
            });

            //console.log(tempArray);
            var objCount = Object.values(tempArray[0]);
            //console.log(objCount.length);
            if(objCount.length === 1){
                console.log("problem");
            }else{
                var reducedObj = tempArray.reduce((r, o, _, a) =>
                        Object.assign(
                            ...products.map(k =>
                                ({ [k.name]: (r[k.name] || 0) + (o[k.name].toString().endsWith('%')
                                        ? o[k.name].slice(0, -1) / a.length
                                        : o[k.name])
                                }))
                        ),
                    {}
                );

                //console.log(reducedObj);
                var tempProdArray = [];
                productArray.map((item) => {
                    tempProdArray.push({
                        "name" : item.name,
                        "count" : reducedObj[item.name]
                    });
                });

                //console.log(tempProdArray);
                var palette = distinctColors({count: tempProdArray.length});
                setPaletteArray(palette);
                setDataArray([...tempProdArray]);

            }
        }


    }, [moment, products, props, sales, todayNum]);


    return (
        <ResponsiveContainer height={400} className="d-flex justify-content-center text-center">
            {dataArray.length === 0 ?
                loading ? <div className="spinner-border text-center ml-2 indigo-text spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                </div> : <div className="text-center">No data to show</div>
                :
                <PieChart>
                    <Legend />
                    <Tooltip />

                    <Pie data={dataArray} dataKey="count" nameKey="name" legendType="circle">
                        {
                            dataArray.map((color, index) => <Cell key={`cell-${index}`} fill={paletteArray[index]} />)
                        }
                    </Pie>

                </PieChart>}
        </ResponsiveContainer>
    );
}

export default MostSoldProduct;
